import { Injectable } from '@angular/core';
import { Subject, Observable, of } from 'rxjs';
import { CalendarFiltersState } from '../state/calendar-filter/state';
import { MonitorFiltersState } from '../state/monitor-filters/state';

@Injectable()
export class FiltersFacade {
  clearAllFiltersSubject: Subject<undefined> = new Subject<undefined>();

  filters$: Observable<CalendarFiltersState | MonitorFiltersState> = of({});

  get clearAllFiltersSubject$(): Observable<undefined> {
    return this.clearAllFiltersSubject.asObservable();
  }

  onClearAllFilters(): void {
    this.clearAllFiltersSubject.next();
  }

  onGridFilterChange(event): void {
    return;
  }

  clearFilter(name: string, subFilterName: string = undefined): void {
    this.onGridFilterChange({
      name,
      value: undefined
    });
  }
}
